import _regenerator from "D:/WebBuild/teamCity/buildAgent/work/f0b2174a44415a20/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "D:/WebBuild/teamCity/buildAgent/work/f0b2174a44415a20/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import { cloneDeep } from 'lodash';
import client from 'webpack-theme-color-replacer/client';
import forElementUI from 'webpack-theme-color-replacer/forElementUI';
export default {
  namespaced: true,
  state: {
    // 颜色
    value: process.env.VUE_APP_ELEMENT_COLOR
  },
  actions: {
    /**
     * @description 设置颜色
     * @param {Object} context
     * @param {String} color 尺寸
     */
    set: function set(_ref, color) {
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var state, dispatch, commit, old;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              state = _ref.state, dispatch = _ref.dispatch, commit = _ref.commit;
              // 记录上个值
              old = state.value; // store 赋值
              state.value = color || process.env.VUE_APP_ELEMENT_COLOR;
              // 持久化
              _context.n = 1;
              return dispatch('d2admin/db/set', {
                dbName: 'sys',
                path: 'color.value',
                value: state.value,
                user: true
              }, {
                root: true
              });
            case 1:
              // 应用
              commit('apply', {
                oldColor: old,
                newColor: state.value
              });
            case 2:
              return _context.a(2);
          }
        }, _callee);
      }))();
    },
    /**
     * @description 从持久化数据读取颜色设置
     * @param {Object} context
     */
    load: function load(_ref2) {
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var state, dispatch, commit, old;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              state = _ref2.state, dispatch = _ref2.dispatch, commit = _ref2.commit;
              // 记录上个值
              old = state.value; // store 赋值
              _context2.n = 1;
              return dispatch('d2admin/db/get', {
                dbName: 'sys',
                path: 'color.value',
                defaultValue: process.env.VUE_APP_ELEMENT_COLOR,
                user: true
              }, {
                root: true
              });
            case 1:
              state.value = _context2.v;
              // 应用
              commit('apply', {
                oldColor: old,
                newColor: state.value
              });
            case 2:
              return _context2.a(2);
          }
        }, _callee2);
      }))();
    }
  },
  mutations: {
    /**
     * @description 将 vuex 中的主题颜色设置应用到系统中
     * @param {Object} context
     * @param {Object} payload oldColor {String} 旧的颜色
     * @param {Object} payload newColor {String} 新颜色
     */
    apply: function apply(state, _ref3) {
      var oldColor = _ref3.oldColor,
        newColor = _ref3.newColor;
      var options = {
        oldColors: cloneDeep(forElementUI.getElementUISeries(oldColor)),
        newColors: cloneDeep(forElementUI.getElementUISeries(newColor))
      };
      client.changer.changeColor(options);
    }
  }
};